<template>
    <div class="identify-json-viewer">
        <template v-if="isCollapsible">
            <div class="accordion" :id="`features-${id}`">
                <template v-for="(feature, idx) in features">
                    <div class="card accordion"
                        :key="`feature-${idx}`"
                        :id="`feature-${idx}`">
                        <div
                            class="card-header"
                            :id="`headingFeature-${idx}`"
                            >
                            <div class="row no-gutters">
                                <div
                                    class="col d-flex align-items-center align-items-start p-0 "
                                    data-toggle="collapse"
                                    :data-target="`#collapse-${id}-${idx}`"
                                    :aria-controls="`collapse-${id}-${idx}`"
                                    :aria-expanded="expandId == featureId(feature)"
                                >
                                    <span>{{ getTitle(feature) }}</span>
                                </div>
                                <div class="col col-auto min-w-auto w-auto p-0">
                                    <div class="btn-group w-100" role="group" aria-label="Feature Actions">
                                        <button v-for="(action, aix) in globalActionsFeatureInfo(feature)"
                                            :key="`action-feature-${aix}`"
                                            type="button"
                                            class="btn btn-sm min-w-auto d-flex flex-row text-nowrap align-items-center"
                                            :class="[!!action.label ? 'btn-main' : 'btn-link', action.class]"
                                            @click.prevent="onGlobalAction(action, feature)">
                                            <i v-if="action.icon"
                                                data-toggle="tooltip-city"
                                                data-placement="left"
                                                :title="action.title"
                                                class="action"
                                                :class="action.icon">
                                            </i>
                                            <span :class="{'pl-2': !!action.icon}" v-if="action.label" v-html="$sanitize(action.label)"></span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="collapse"
                            :class="{'show': expandId == featureId(feature)}"
                            :id="`collapse-${id}-${idx}`"
                            :aria-labelledby="`headingFeature-${idx}`"
                            :data-parent="`#features-${id}`">
                            <div class="card-body">
                                <RowViewer
                                    :key="featureId(feature)"
                                    :feature="feature"
                                    :exclude="excludeProps"
                                    :featureInfo="featureInfo"
                                    :properties="{...feature.properties}"
                                    @emitOpenPopup="onOpenPopup"
                                    @dispatchEvent="onDispatchEvent" />
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </template>
        <template v-else  v-for="(feature, idx) in features">
            <RowViewer
                :key="featureId(feature)"
                :feature="feature"
                :title="getTitle(feature)"
                :exclude="excludeProps"
                :featureInfo="featureInfo"
                :properties="{...feature.properties}"
                @emitOpenPopup="onOpenPopup"
                @dispatchEvent="onDispatchEvent"
                 />
        </template>

        <info-modal
            ref="infoModal"
            :class="popupClassName"
            v-if="popup.component"
            :propTitle="propTitle"
            :component="popup.component"
            :enablePrint="true"
            @close="onClosePopup"
        />
            <!-- :moduleCode="moduleCode"
            :urlPrint="urlPrintData"
            :enablePrint="enablePrintDataPatrimony"
            :printDescription="printDescription"
            :printTitleList="printTitleList"
            :printEmptyResult="printEmptyResult" -->

    </div>
</template>

<script>
    import RowViewer from './row/RowPropertiesViewer';
    import FormViewer from './popup/FormPropertiesViewer';
    import { getFeatureId } from '../../catalog/utils/IdentifyUtils';
    import { isJson, toSnakeCase, operations } from '@config/utils';

    export default {
        name: 'PropertiesViewer',
        mixins: [
        ],
        components: {
            RowViewer: RowViewer,
            InfoModal: () => import(/* webpackChunkName: "info-modal" */ '@/components/maps/shared/identify/components/IdentifyInfoModal'),
        },
        props: {
            response: {
                type: Object,
                default: () => {},
            },
            layer: {
                type: Object,
                default: () => {},
            },
            collapsible: {
                type: Boolean,
                default: true,
            },
            enableTitlePrefix: {
                type: Boolean,
                default: true,
            },
            activeItemId: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                id: null,
                popup: {
                    url: null,
                    component: FormViewer,
                }
            }
        },
        computed: {
            features() {
                return this.response && this.response.features ? this.response.features : [];
            },
            featureInfo() {
                return this.layer.featureInfo;
            },
            paramsFeatureInfo() {
                return this.featureInfo && this.featureInfo.params ? (isJson(this.featureInfo.params) ? JSON.parse(this.featureInfo.params) : this.featureInfo.params) : {};
            },
            excludeProps() {
                return [...['bbox'], ...(this.featureInfo?.exclude ?? [])];
            },
            propTitle() {
                return this.featureInfo ? this.featureInfo.prop_title : null;
            },
            isCollapsible() {
                return this.collapsible && this.featureInfo ? this.featureInfo.collapsible : null;
            },
            expandId() {
                return this.activeItemId || (this.isCollapsible && this.features.length == 1 ? this.featureId(this.features[0]) : null);
            },
            layerName() {
                return this.features && this.features.length > 0 ? this.extractNameFromFid(this.features[0].id || null) : null;
            },
            popupClassName() {
                let cls = [this.layerName ? toSnakeCase(this.layerName) : null];
                if(this.paramsFeatureInfo && this.paramsFeatureInfo.class) {
                    cls.push(this.paramsFeatureInfo.class);
                }
                return cls.filter(el => !!el).join(' ');
            },
        },
        mounted () {
            this.id = this._uid;
        },
        methods: {
            onOpenPopup(url, feature, params = {}, tools = {}) {
                let modal = this.$refs.infoModal;
                if(modal) {
                    this.$refs.infoModal.onOpenPopup(this.getValuePropTitle(feature), url, false, params, tools);
                }
            },
            onClosePopup() {

            },
            extractNameFromFid(fid){
                if(fid.indexOf('.fid') !== -1){
                    let parts = fid.split(".fid");
                    return parts[0];
                }
                return fid;
            },
            globalActionsFeatureInfo(feature) {
                let actions = this.featureInfo?.actions || [];
                let properties = feature?.properties || {};
                return actions
                        .filter(a => !!!a.prop && (a.acl_code ? this.$auth.check(a.acl_code) : true))
                        .filter(a => {
                            let params = a.params || {};
                            params = this.replacePlaceholders(properties, params);
                            let conditions = params.conditions || [];
                            return conditions.length ? conditions.find(c => {
                                return operations(c.if_field, c.operator, c.if_value);
                            }) != null : true;
                        })
                        .map(a => {
                            let params = a.params || {};
                            return {
                                icon: params.icon,
                                label: params.label,
                                title: params.title ? this.$t(`${params.title}`) : null,
                                ...params
                            }
                        });
            },
            onGlobalAction(action, feature) {
                let properties = feature?.properties || {};
                let params = action?.params?.params || action?.params || {};
                params = this.replacePlaceholders(properties, params);
                if(action.params?.params) action.params.params = params;
                else if(action.params) action.params = params;

                this.onDispatchEvent(action, feature);
            },
            getTitle: function(feature) {
                return (this.propTitle && feature.properties[this.propTitle] ?
                    (this.enableTitlePrefix ? `${this.propTitle}: ${feature.properties[this.propTitle]}` : `${feature.properties[this.propTitle]}`)
                    : this.extractNameFromFid(feature.id)) + '';
            },
            getValuePropTitle: function(feature) {
                return (this.propTitle && feature.properties[this.propTitle] ?
                    (this.enableTitlePrefix ? `${feature.properties[this.propTitle]}` : `${feature.properties[this.propTitle]}`)
                    : this.featureId(feature)) + '';
            },
            onDispatchEvent(args, feature) {
                this.$eventBus.publish(null, args.eventName, {callback: this.onCallbackEvent, feature, ...args.params});
            },
            onCallbackEvent(args={}) {
                if(args?.close){
                    this.$emit('close', args);
                }
            },
            featureId(feature){
                return getFeatureId(feature);
            },
            replacePlaceholders(properties, data){
                data = JSON.stringify(data);
                for (let v in properties) {
                    var regexp = new RegExp(`:${v}`, 'gi');
                    data = data.replace(regexp, properties[v] ? properties[v] : '');
                }
                data = JSON.parse(data);
                return data;
            }
        }
    }

</script>

<style scoped lang="scss">
.card {

    .card-header {
        padding: 0.25rem 1.25rem !important;
        font-size: 1rem !important;

        .btn {
            margin: 0;
            margin-left: .5rem;
            &:first-child {
                margin-left: 0;
            }
            &.btn-link {
                color: inherit;
                padding: 0;
            }
        }
        .btn:hover,
        .btn:active {
            box-shadow: none;
        }
    }
}
</style>

<style lang="scss">
.modal-identify-viewer {
    &:not(.auto-height) {
        .modal-body {
            min-height: 70vh;
            height: 1px;
        }
    }
    &.auto-height {
        .modal-body {
            .panel-form-data.loading {
                padding-top: 3rem;
                padding-bottom: 3rem;
            }
        }
    }
}
</style>